"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseReporter2 = _interopRequireDefault(require("./BaseReporter"));

var ProdConsoleReporter = /*#__PURE__*/function (_BaseReporter) {
  (0, _inherits2.default)(ProdConsoleReporter, _BaseReporter);

  function ProdConsoleReporter() {
    var _this;

    (0, _classCallCheck2.default)(this, ProdConsoleReporter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProdConsoleReporter).call(this));
    _this.resolved = {};
    return _this;
  }

  (0, _createClass2.default)(ProdConsoleReporter, [{
    key: "report",
    value: function report(action) {
      var _this2 = this;

      var _action$payload = action.payload,
          _action$payload$entry = _action$payload.entry,
          pathname = _action$payload$entry.pathname,
          timestamp = _action$payload$entry.timestamp,
          expiredTimestamp = _action$payload$entry.expiredTimestamp,
          checks = _action$payload$entry.checks,
          id = _action$payload$entry.id,
          routeSpec = _action$payload.routeSpec;

      if (this.resolved[id] && action.type !== 'CHECKS_CHANGED') {
        return;
      }

      if (!this.debug) {
        return;
      }

      var log = function log() {
        var _console;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_console = console).log.apply(_console, ["[" + _this2.libName + "]", pathname].concat(args));
      };

      var formatDuration = function formatDuration(num) {
        return num.toFixed(2) + "ms";
      };

      switch (action.type) {
        case 'ROUTE_STARTED':
          {
            var route = routeSpec.route;
            log("(" + route + ")");
            break;
          }

        case 'ROUTE_UNEXPECTED':
          {
            log("(unexpected)");
            break;
          }

        case 'ROUTE_ABANDONED':
          {
            log("(abandoned)");
            break;
          }

        case 'ROUTE_SUCCEEDED':
          {
            var scenario = action.payload.extra.scenario;
            var duration = this.toDuration(checks, timestamp, routeSpec.success[scenario]);
            log("(success) " + formatDuration(duration));
            break;
          }

        case 'ROUTE_FAILED':
          {
            var error = routeSpec.error;

            var _duration = this.toDuration(checks, timestamp, error);

            log("(failure) " + formatDuration(_duration));
            break;
          }

        case 'ROUTE_TIMEOUT_EXPIRED':
          {
            var _duration2 = expiredTimestamp - timestamp;

            log("(timeout) " + formatDuration(_duration2));
            break;
          }

        case 'CHECKS_CHANGED':
          {
            log("(update)");
            break;
          }

        default:
      }

      switch (action.type) {
        case 'ROUTE_STARTED':
        case 'CHECKS_CHANGED':
          break;

        default:
          this.resolved[id] = true;
      }
    }
  }]);
  return ProdConsoleReporter;
}(_BaseReporter2.default);

exports.default = ProdConsoleReporter;
module.exports = exports.default;